"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { loadDatadogRum } from "./datadog-rum";

/**
 * Datadog RUM を初期化する。
 *
 * 計測しない画面（excludedPathPattern に一致するパス）では閲覧・操作を送らない。
 * - 計測しない画面にいる間は RUM を読み込まず、計測する画面に初めて入ったときに読み込む。
 *   メールのリンクから受検・結果の画面を開いた場合は何も送らず、その後に移った画面から計測を始める
 * - 読み込んだ後に画面内の移動で計測しない画面へ入った場合は、beforeSend でその画面の操作・リソース・エラーを捨て、
 *   閲覧（view）の URL と参照元を切り詰める（createBeforeSend）
 * - Session Replay は beforeSend を通らないため、計測しない画面の要素に data-dd-privacy="hidden" を付けて録画から隠す
 */
export const DatadogRumInit = ({
  excludedPathPattern,
}: {
  // 計測しない画面のパスの正規表現（source）。match の [0] を画面の種類までのパスとして URL を切り詰める
  excludedPathPattern: string;
}) => {
  const pathname = usePathname();
  const isExcludedPath = new RegExp(excludedPathPattern).test(pathname);

  // Datadog RUM（外部の計測サービス）の読み込み。計測する画面に入ったときに一度だけ行う
  useEffect(() => {
    if (isExcludedPath) {
      return;
    }
    loadDatadogRum(new RegExp(excludedPathPattern));
  }, [excludedPathPattern, isExcludedPath]);

  return null;
};
